import React from 'react';
import './MyRole.css';

function MyRolePL() {
  return (
    <div className="section-container">
      {/* Main heading and subtitle */}
      <h2 className="main-heading">
        Moja rola <span className="heading-subtitle">Zakres odpowiedzialności</span>
      </h2>

      {/* Business Partners */}
      <h3 className="section-heading">Partnerzy biznesowi:</h3>
      <ul className="role-list">
        <li>
          <strong>Ścisła współpraca z Product Owners</strong> (PO) w celu dopasowania potrzeb interesariuszy do funkcjonalności aplikacji.
        </li>
        <li>
          <strong>Identyfikacja wyzwań UX/UI design</strong> poprzez wskazywanie pain points i wdrażanie skutecznych rozwiązań projektowych.
        </li>
        <li>
          Zapewnienie spójności <strong>między potrzebami użytkowników a celami biznesowymi</strong> w całym procesie projektowym.
        </li>
        <li>
          <strong>Odświeżanie wyglądu</strong> i poprawa użyteczności różnych <strong>desktop i mobile applications</strong> dla kluczowych klientów, identyfikacja problemów i iteracja projektów na podstawie feedbacku.
        </li>
        <li>
          <strong>Współpraca z developers</strong> w środowisku <strong>Agile</strong> w celu efektywnego i elastycznego wdrażania rozwiązań projektowych dla projektów klientów.
        </li>
      </ul>

      {/* Backstage Partners */}
      <h3 className="section-heading">Partnerzy zaplecza:</h3>
      <ul className="role-list">
        <li>
          <strong>Zwiększanie użyteczności</strong> wewnętrznych <strong>developer tools</strong>, czyniąc je bardziej przyjaznymi i efektywnymi.
        </li>
        <li>
          <strong>Modernizacja i rozwój nowych narzędzi</strong> wspierających zespoły developerskie w codziennej pracy.
        </li>
        <li>
          <strong>Zapewnienie spójności UX/UI</strong> w aplikacjach dla developerów, tworzenie intuicyjnych i wizualnie spójnych rozwiązań.
        </li>
        <li>
          <strong>Dostarczanie zarówno drobnych, jak i dużych usprawnień UX/UI</strong> w celu optymalizacji funkcjonalności i doświadczenia narzędzi developerskich.
        </li>
      </ul>

      {/* Team Collaboration */}
      <h3 className="section-heading">Współpraca zespołowa:</h3>
      <ul className="role-list">
        <li>
          <strong>10 zespołów developerskich</strong> pracujących w metodykach Agile i Waterfall (wdrożeniowcy i programiści)
        </li>
        <li>
          Zespoły <strong>product management</strong> z <strong>Polski i Niemiec</strong>
        </li>
        <li>
          <strong>Product owners</strong>
        </li>
        <li>
          <strong>Technical writers</strong>
        </li>
      </ul>
    </div>
  );
}

export default MyRolePL; 